import "./LoadingSmall.css";
import "./LoadingLarge.css";

export function LoadingSmall() {
  return (
    <div className="flex justify-center items-end h-20">
      <div className="flex justify-center items-center p-0">
        <div className="dot-flashing-small-row1" />
      </div>
      <div className="flex justify-center items-center">
        <div className="dot-flashing-small-row2" />
      </div>
      <div className="flex justify-center items-center p-0">
        <div className="dot-flashing-small-row3" />
      </div>
      <div className="flex justify-center items-center">
        <div className="dot-flashing-small-row4" />
      </div>
      <div className="flex justify-center items-center p-0">
        <div className="dot-flashing-small-row5" />
      </div>
      <div className="flex justify-center items-center">
        <div className="dot-flashing-small-row6" />
      </div>
      <div className="flex justify-center items-center p-0">
        <div className="dot-flashing-small-row7" />
      </div>
      <div className="flex justify-center items-center">
        <div className="dot-flashing-small-row8" />
      </div>
      <div className="flex justify-center items-center p-0">
        <div className="dot-flashing-small-row9" />
      </div>
    </div>
  );
}

export function LoadingLarge() {
  return (
    <div className="mx-auto max-w-7xl sm:px-6 lg:px-8 mb-32 mt-48 relative group">
      <div className="flex justify-center items-end">
        <div className="flex justify-center items-center p-0">
          <div className="dot-flashing-large-row1" />
        </div>
        <div className="flex justify-center items-center">
          <div className="dot-flashing-large-row2" />
        </div>
        <div className="flex justify-center items-center p-0">
          <div className="dot-flashing-large-row3" />
        </div>
        <div className="flex justify-center items-center">
          <div className="dot-flashing-large-row4" />
        </div>
        <div className="flex justify-center items-center p-0">
          <div className="dot-flashing-large-row5" />
        </div>
        <div className="flex justify-center items-center">
          <div className="dot-flashing-large-row6" />
        </div>
        <div className="flex justify-center items-center p-0">
          <div className="dot-flashing-large-row7" />
        </div>
        <div className="flex justify-center items-center">
          <div className="dot-flashing-large-row8" />
        </div>
        <div className="flex justify-center items-center p-0">
          <div className="dot-flashing-large-row9" />
        </div>
      </div>
    </div>
  );
}
